import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SystemConfigService } from '../services/data/system-config.service';
import { SystemModule } from '../api/system-config/system-module';

@Injectable()
export class SystemSetParkevalModuleGuard  {

  constructor(private systemConfig: SystemConfigService) { }

  public canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    this.systemConfig.setModule(SystemModule.ParkEval);
    return true;
  }

  public canDeactivate(
    component: any,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): boolean {

    this.systemConfig.setModule(SystemModule.None);
    return true;
  }
}
